export const NOTIFICATIONS_COUNT_QUERY = `
  query NotificationsCountQuery {
    me {
      newNotificationsCount(type: ALL_BUT_ALERTS_AND_CHAT)
    }
  }
`;
